import {Base} from "@/api/Base"

export class EmployeeDelete extends Base {
    path = "employee/delete"
}